module.exports = __webpack_public_path__ + "7d10f0afd26a833a0e50ee68e410f969.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/luxury-apartments-empty.png
// module id = 327
// module chunks = 0